/** @type {() => PackageNameList} */
export const getPackageName = () => {
    try {
        /** @type {PackageNameList} */
        let packageName;
        const searchString = '/#/';
        const { search } = window.location;

        if (window.location.href.includes(searchString)) {
            window.location.href = window.location.href.replace(searchString, '#/');
        }

        const urlParams = new URLSearchParams(search);

        // @ts-ignore
        packageName = urlParams.get('packageName');

        if (!packageName &&
            (location.hostname === 'localhost' ||
                location.hostname.includes('192.168.0.') ||
                location.hostname.includes('test.app.')
            )
        ) packageName = 'com.denticalc.4in1';

        return packageName;
    }
    catch (error) {
        window.captureException(error);

        // @todo set default to 'com.denticalc.4in1' after the required update of the old apps (when all users updated)
        // @ts-ignore
        return '';
    }
}
